import React, { useEffect, useState } from 'react'
import ExpenseStatementTable from './ExpenseStatementTable/ExpenseStatementTable'
import { getExpenseStatement } from '../../utils/ActionCreator';
import SpinnerLoader from '../../../../../../../presentationals/Loader/Loader.component';

function ExpenseStatemement() {
    const [expenseStatement, setExpenseStatement] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchExpenseStatement = () => {
        setLoading(true);
        getExpenseStatement((callback) => {
            if (callback.status === 200) {

                setExpenseStatement(callback.data)
            }

            setLoading(false);

        }, (onErr) => {
            setLoading(false);

        })
    }
    useEffect(()=>{
        fetchExpenseStatement();
    },[])


    return (
        <>
            {loading && <SpinnerLoader />}
            {expenseStatement.map((item) => {
                return (
                    <>
                        {item?.monthlyData !== null && Array.isArray(item?.monthlyData) && item?.monthlyData?.length > 0 &&
                        <div style={{marginTop:"4rem"}}>

                            <ExpenseStatementTable item={item?.monthlyData ?? []} productName={item?.productName ?? ""} />
                        </div>    
                        
                        }
                    </>
                )
            })}
        </>
    )
}

export default ExpenseStatemement